"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _DatePicker = _interopRequireDefault(require("../../../../DatePicker"));
var _hooks = require("../../../hooks");
var _utils = require("../../../utils");
var _usePrevious = _interopRequireDefault(require("../../../../../hooks/usePrevious"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var DatePicker = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var children = props.children,
    disabled = props.disabled,
    name = props.name,
    propsOnChange = props.onChange,
    plainDatePickerProps = __rest(props, ["children", "disabled", "name", "onChange"]);
  var _a = (0, _hooks.useInputLogic)({
      defaultValue: "",
      disabled: disabled,
      name: name
    }),
    additionalInputProps = _a.additionalInputProps,
    clearValidationMessages = _a.clearValidationMessages,
    disabledCombined = _a.disabled,
    onBlur = _a.onBlur,
    setFieldValue = _a.setFieldValue,
    validateOnChange = _a.validateOnChange,
    value = _a.value;
  var previousValue = (0, _usePrevious.default)(value);
  var onChange = (0, _react.useCallback)(function (date, event) {
    setFieldValue(name, (0, _utils.getDateValue)(date));
    clearValidationMessages(name);
    validateOnChange(name, (0, _utils.getDateValue)(date));
    if (propsOnChange) {
      propsOnChange(date, event);
    }
  }, [setFieldValue, name, clearValidationMessages, validateOnChange, propsOnChange]);
  (0, _react.useEffect)(function () {
    if (previousValue !== value) {
      onBlur();
    }
  }, [onBlur, previousValue, value]);
  return (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [(0, _jsxRuntime.jsx)(_DatePicker.default, __assign({
      ref: ref,
      disabled: disabledCombined,
      id: name,
      name: name,
      onChange: onChange,
      minDate: additionalInputProps.minDate,
      maxDate: additionalInputProps.maxDate
    }, (0, _utils.buildDatePickerValueProps)(value), plainDatePickerProps)), children]
  });
});
var _default = DatePicker;
exports.default = _default;